import GoogleIntegration from 'models/application/integration/GoogleIntegration';

export default class GoogleIntegrationService {
	toModel(integration) {
		return new GoogleIntegration(integration);
	}
}
